const BADGES = {
    "default":"grey-background-50",
    "error":"red-background-50",
    "succes":"success-background-50",
    "info":"primary-background-50",
    "gepauzeerd": "warning-background-50", 
    "actief": "success-background-50", 
    "inactief": "inactief-background",
    "afgerond": "primary-background-50", 
    "none":"none"
}
const TEXT = {
    'default':"grey-600",
    "error":"red-500",
    "succes":"success-500",
    "info":"primary-500",
    "gepauzeerd": "warning-600", 
    "actief": "success-500",
    "inactief": "inactief-color",
    "afgerond": "primary-700" 
    
}

export function Badge({label,rounded,badge,slim, style}){
    return(
        <div data-testid={'badge1'} style={{...style, padding: (slim ? "0px 8px" : "")}} className={`badge ${(rounded)&&'rounded-badge standard-margin-bottom'} ${BADGES[badge]}`}>
            <p className={`xsmall-text bold-medium  ${TEXT[badge]}`}>{label}</p>
        </div>
    )
}
